<div class="reset-password-container">
  <div class="reset-password-container-card">
    <a routerLink="/">
      <img class="reset-password-container-card--logo" src="assets\logos\logo-projeto.svg">
    </a>

    <form class="reset-password-container-card--form" #form="ngForm" (ngSubmit)="resetPassword()">
      <div class="reset-password-container-card--form-input">
        <label for="email">Email:</label>
        <input type="email" email id="email" name="email" [(ngModel)]="resetPasswordForm.email" #email="ngModel" class="form-control" placeholder="Digite o seu e-mail" required>

        <div class="reset-password-container-card--form-input-error" *ngIf="email.invalid && (email.dirty || email.touched)">
          <mat-error *ngIf="email.invalid">Digite o e-mail no formato correto</mat-error>
          <mat-error *ngIf="email.errors?.['required']">Este campo é obrigatório</mat-error>
        </div>
      </div>
      <button class="btn btn-primary reset-password-container-card--form-submit" type="submit" [disabled]="form.invalid">Enviar</button>
    </form>
    <a routerLink="/login">Lembrou a sua senha? Acesse já!</a>
  </div>
</div>
